import loadable from '@loadable/component';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Heading } from 'components/Heading/Heading';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { ViewTogglerContainer } from './ViewTogglerContainer';
import { messages } from './VenueSupply.messages';
import css from './VenueSupply.scss';

const SearchContainer = loadable(() => import('features/Search/SearchContainer'), { ssr: false });

export class VenueSupply extends PureComponent {
  render() {
    const { shouldHide } = this.props;

    const style = shouldHide ? { display: 'none' } : null;

    return (
      <div className={css.VenueSupply} style={style}>
        <div className={css['VenueSupply__top-section']}>
          <Heading className={css.VenueSupply__title}>
            <LocalizableMessage message={messages.title} />
          </Heading>
          <p className="mt-regular qa-subtitle">
            <LocalizableMessage message={messages.subtitle} />
          </p>
          <Link className="mb-regular bt bt--lg bt--primary" to="/search" target="_self">
            <LocalizableMessage message={messages.showAllCta} />
          </Link>
        </div>
        <SearchContainer isInVenueSupply data-qa="SearchContainer" />
        <ViewTogglerContainer />
      </div>
    );
  }
}

VenueSupply.propTypes = {
  shouldHide: PropTypes.bool,
};
